import isValidTitle from './is-valid-title';
import replaceTitleInHtml from './replace-title-in-html';
import composeAssetUrl from './compose-asset-url';
import fetchAsset from './fetch-asset';
import injectSiteEmailsSettings from './inject-site-emails-settings';
import injectSiteSettings from './inject-site-settings';
import injectSiteSocialLinksSettings from './inject-site-social-links-settings';
import disableVariablesTextEditing from './disable-variables-text-editing';
import fetchPageHTML from './fetch-page-html';
import removeAssetUrl from './remove-asset-url';

export default {
  replaceTitleInHtml,
  isValidTitle,
  composeAssetUrl,
  fetchAsset,
  injectSiteEmailsSettings,
  injectSiteSettings,
  injectSiteSocialLinksSettings,
  disableVariablesTextEditing,
  fetchPageHTML,
  removeAssetUrl,
};
